export default __webpack_public_path__ + "static/media/royalty-cover.0a5ffcde.jpg";